import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { StcPageInitialData } from "./stcPageInitialData";

export const stcPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("stc"),
    queryFn: () => fetchOccPageData<PageInitialDataResult<StcPageInitialData>>("/page-data/stc"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
